import colors from '@/config/colors';
import { openLink } from '@/utils/linkHelpers';
import { Text } from '@/components/Text';
import { TextProps } from 'react-native-elements';

export function TextLink({
  href,
  children,
  ...props
}: TextProps & { href: string }) {
  return (
    <Text
      onPress={() => openLink(href)}
      style={{
        color: colors.darkPurpleBlue,
      }}
      {...props}
    >
      {children}
    </Text>
  );
}
